import { gql } from '@apollo/client';

export const GET_ORGANISATIONS_BY_IDS = gql`
  query GetOrganisationsByID($input: OrganisationByIDInput!) {
    organisation: getOrganisationsByID(input: $input) {
      id
      isFunder
      isInstitution
      isServiceProvider
      funder {
        id
        name
      }
      institution {
        id
        name
      }
      serviceProvider {
        id
        name
      }
    }
  }
`;
